import React from "react";
import { IngresosProvider } from "../Context/IngresosContext";
import IngresosContent from "./Ingresos/IngresosContent";

const Ingresos = () => {
  return (
    <IngresosProvider>
      <IngresosContent />
    </IngresosProvider>
  );
};

export default Ingresos;